import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=1ad78ba6&"
import script from "./MasterPage.vue?vue&type=script&lang=ts&"
export * from "./MasterPage.vue?vue&type=script&lang=ts&"
import style0 from "./MasterPage.vue?vue&type=style&index=0&id=1ad78ba6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports